import BoldText from '@/components/BoldText';
import InformationBanner from '@/components/InformationBanner';
import RegularText from '@/components/RegularText';
import { config } from '@/config';
import { WIDGET_DISPLAY_CHOICE } from '@/constants/enum';
import { StyledBoldText } from '@/pages/WidgetAppearance/styled';
import { handleVisibleBanner, isOpenDisplayDatePickerInstructionBannerSelector } from '@/redux/slice/banner.slice';
import { handleSaveShopInfo } from '@/redux/slice/shop.slice';
import { handleSaveWidgetSettings, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { Badge, BlockStack, Box, Card, InlineStack, RadioButton } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const DatePickerShow = () => {
  const { t } = useTranslation('widget_settings');
  const widgetSettings = useSelector(widgetSettingSelector);
  const isOpenDisplayDatePickerInstructionBanner = useSelector(isOpenDisplayDatePickerInstructionBannerSelector);
  const dispatch = useDispatch();

  return (
    <Card padding={'300'}>
      <BlockStack gap={'300'}>
        <BoldText>{t('position.datePicker.title')}</BoldText>
        <InformationBanner
          isVisible={isOpenDisplayDatePickerInstructionBanner}
          onDismiss={() => dispatch(handleVisibleBanner({ key: 'isOpenDisplayDatePickerInstructionBanner', value: false }))}
        >
          <RegularText>{t('position.datePicker.bannerContent')}</RegularText>
        </InformationBanner>
        <BlockStack gap={'050'}>
          <RadioButton
            label={
              <InlineStack gap={'200'}>
                <RegularText>{t('position.datePicker.cart.label')}</RegularText>
                <StyledBoldText>
                  <Badge tone="success">{t('position.datePicker.cart.badge')}</Badge>
                </StyledBoldText>
              </InlineStack>
            }
            checked={
              widgetSettings.widgetPosition.displayOnPage.length === 1 &&
              widgetSettings.widgetPosition.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.CART)
            }
            id="widget-cart-position"
            name="widget-cart-position"
            onChange={() => {
              dispatch(
                handleSaveWidgetSettings({
                  widgetPosition: { ...widgetSettings.widgetPosition, displayOnPage: [WIDGET_DISPLAY_CHOICE.CART] },
                }),
              );
              dispatch(handleSaveShopInfo({ isDisableCheckoutButton: true }));
            }}
          />
          <Box paddingInlineStart={'600'}>
            <RegularText tone="subdued">{t('position.datePicker.cart.helpText')}</RegularText>
          </Box>
        </BlockStack>

        {config.scope === 'omegatheme' && (
          <BlockStack gap={'050'}>
            <RadioButton
              label={
                <InlineStack gap={'200'}>
                  <RegularText>{t('position.datePicker.both.label')}</RegularText>
                  <StyledBoldText>
                    <Badge tone="info">{t('position.datePicker.both.badge')}</Badge>
                  </StyledBoldText>
                </InlineStack>
              }
              checked={
                widgetSettings.widgetPosition.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.PRODUCT) &&
                widgetSettings.widgetPosition.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.CART)
              }
              id="widget-both-position"
              name="widget-both-position"
              onChange={() =>
                dispatch(
                  handleSaveWidgetSettings({
                    widgetPosition: {
                      ...widgetSettings.widgetPosition,
                      displayOnPage: [WIDGET_DISPLAY_CHOICE.PRODUCT, WIDGET_DISPLAY_CHOICE.CART],
                    },
                  }),
                )
              }
            />
            <Box paddingInlineStart={'600'}>
              <RegularText tone="subdued">{t('position.datePicker.both.helpText')}</RegularText>
            </Box>
          </BlockStack>
        )}

        <BlockStack gap={'050'}>
          <RadioButton
            label={
              <InlineStack gap={'200'}>
                <RegularText>{t('position.datePicker.product.label')}</RegularText>
                <StyledBoldText>
                  <Badge tone="attention">{t('position.datePicker.product.badge')}</Badge>
                </StyledBoldText>
              </InlineStack>
            }
            checked={
              widgetSettings.widgetPosition.displayOnPage.length === 1 &&
              widgetSettings.widgetPosition.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.PRODUCT)
            }
            id="widget-product-position"
            name="widget-product-position"
            onChange={() => {
              dispatch(
                handleSaveWidgetSettings({
                  widgetPosition: { ...widgetSettings.widgetPosition, displayOnPage: [WIDGET_DISPLAY_CHOICE.PRODUCT] },
                }),
              );
              dispatch(handleSaveShopInfo({ isDisableAddToCartButton: true }));
            }}
          />
          <Box paddingInlineStart={'600'}>
            <RegularText tone="subdued">{t('position.datePicker.product.helpText')}</RegularText>
          </Box>
        </BlockStack>
      </BlockStack>
    </Card>
  );
};
